<template>
	<div>
		<div :id="uuid" :content="text" v-tippy="{ theme : 'customTheme', placement : 'bottom-start', arrow : true }" style="text-overflow: ellipsis; width: 100%; overflow: hidden" >
			{{text}}
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
	name: "ProbablyOverflowingTextCell.vue",
	data() {
		return {
			data: {},
			uuid: "0",
			init: false,
			interval: null
		}
	},
	computed: {
		text() {
			return this.data[this.data.column.field]
		}
	},
	methods: {
		setVisible(){
			if(this.init) {
				try{
					let e = document.getElementById(this.uuid)
					let res = (e.offsetWidth < e.scrollWidth)
					if(res){
						e._tippy.enable()
					} else {
						e._tippy.disable()
					}
					clearInterval(this.interval);
				} catch (ignored) {

				}
			}
		},
	},
	mounted: async function(){
		this.uuid = uuidv4();
		this.init = true
		this.interval = setInterval(() => this.setVisible(), 50);
	},
}
</script>

<style>
.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {
	border-bottom: 8px solid #346F8B;
}
</style>

<style scoped>
.tippy-tooltip.customTheme-theme {
	background-color: #346F8B;
}
</style>


// WEBPACK FOOTER //
// src/components/Systems/ProbablyOverflowingTextCell.vue